import React from 'react'
import { Link } from 'react-router-dom'
import styles from '../HeaderNavigation.module.scss'

const HomepageLogo = ({
  className: classNameProp,
  href = '/',
}: {
  className?: string
  href?: string
}) => {
  return (
    <div className={`${styles.HomepageLogo} ${classNameProp || ''}`}>
      <Link to={href}>
        <img
          src="https://cdn.bfldr.com/52NIVVB5/at/fx7btx2ffn53kpfvvxmnp6v/logo.svg"
          alt="Techstars Universe"
          style={{ height: '40px', width: 'auto' }}
        />
      </Link>
    </div>
  )
}

export default HomepageLogo
